/**
 * @fileoverview functionality from LocationEdit.js that is still required in
 * Fall 2019. Moving it here allows callers to depend upon a smaller body of
 * code. Eventually LocationEdit.js should be deleted.
 */
goog.module('yext.storm.LocationEdit2');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const location = goog.require('yext.location');
const logflownav = goog.require('yext.storm.logflownav');

(function() {
  // Facebook photo options "dropdown" interaction
  /** @suppress {deprecated} */
  var showFacebookOptions = function(el, e) {
    var $el = $(el);
    var $dropdown = $el.parent().find('.fb-photo-dropdown');
    var $arrow = $dropdown.find('.fb-dropdown-arrow');

    $(document).trigger('click.fb-photo-options'); // close any open dropdowns

    // show/hide and position the dropdown
    $dropdown.toggle(0, function() {
      if (!$el.attr('style')) {
        $el.css('display', 'inline');
      } else {
        $el.removeAttr('style');
        $(document).unbind('click.fb-photo-options keydown.fb-photo-options');
      }
    }).position({
      my: 'center top',
      at: 'center bottom',
      of: $el,
      offset: '0 10',
    });

    $arrow.removeClass('invert');
    if ($dropdown.offset().top < $el.offset().top) {
      $arrow.addClass('invert');
    }

    // Close dropdown
    // Supports ESC key & Clicking away (to document)
    $(document).bind('click.fb-photo-options keydown.fb-photo-options', function(e) {
      if (e.type == 'keydown' && e.keyCode == $.ui.keyCode.ESCAPE
          // if the click isn't the button or any of the buttons children
          || e.type == 'click' && ($(e.target).parents('.fb-button.change').length == 0 && !$(e.target).hasClass('fb-button'))) {
        $dropdown.hide();
        $el.removeAttr('style');
        $(document).unbind('click.fb-photo-options keydown.fb-photo-options');
      } else {
        return false;
      }
    });
  };
  goog.exportSymbol('showFacebookOptions', showFacebookOptions);

  var imageLoadError = function(el, src) {
    // IE10 doesn't properly recognize blobs as valid img tags, so we check for this
    if (el.src && ! el.src.substring(0, 4) == 'blob') {
      $(el).closest('.photo').remove();
      $('.gallery-cell').find('.field-freeform-error').text(yext.msg('Invalid image file')).show();
    }
  };

  goog.exportSymbol('imageLoadError', imageLoadError);

  var updateCharCount = function(el, maxlength, optLowCountClass) {
    var countLeft = maxlength - $(el).val().replace(/\n/g, '\n\r').length;
    $(document.getElementById($(el).attr('id') + '.charCount'))
      .html(yext.msgn('1 character remaining', '{0} characters remaining', countLeft))
      .toggleClass(optLowCountClass ? optLowCountClass : '', countLeft < 10);
  };
  goog.exportSymbol('updateCharCount', updateCharCount);

  var enableSubmit = function(formEl) {
    logflownav.enableNextInLogFlow(formEl);
    $(formEl).find('.submit').removeClass('disabled');
    $(formEl).find('button:submit').prop('disabled', false);
    $(formEl).closest('form').data('changed', true);
    location.setBeforeUnload();
  };
  goog.exportSymbol('enableSubmit', enableSubmit);
})();

